import React from 'react';
import numeral from 'numeral';

import { getTitleSalaryStatesMapFileUrl } from '../../../services/mediaBucketS3Service';
import { formatCurrency } from '../../../utils';
import { WIDGET_NAMES } from '../../../utils/constant';

import StatesCountyMap from './index';

import classes from './index.module.css';

const TitleSalaryStatesMap = (props) => {
  const { title } = props;
  const svgFileUrl = getTitleSalaryStatesMapFileUrl(title);

  const gtmEventNames = {
    open: 'Salary Heatmap Modal Open',
  };
  const mapTooltip = {
    title: 'Average Salary',
    valueFormatFunc: formatCurrency,
  };
  const legendTooltip = {
    title: 'Salary Range',
    valueFormatFunc: (range, isLast) => {
      const rangeArr = range.split('-') || [];
      if (!rangeArr || !rangeArr.length) {
        return '';
      }
      return `${numeral(rangeArr[0]).format('$0a')} - ${numeral(rangeArr[1]).format('$0a')}${
        isLast ? '+' : ''
      }`;
    },
  };
  const legendLabelsCallback = (legendItems) => {
    if (!legendItems || !legendItems.length || !legendItems[0].rangeDisplay) {
      return <></>;
    }

    const salaryMinFormatted = legendItems[0].rangeDisplay.split('-')[0];
    const salaryMaxFormatted = legendItems[legendItems.length - 1].rangeDisplay.split('-')[1];

    return (
      <>
        <span className={classes['legend-label-part']}>
          <span className={classes['county-value']}>{salaryMinFormatted}</span>
          <span>Lowest</span>
        </span>
        <span className={classes['legend-label-part']}>
          <span>Highest</span>
          <span className={classes['county-value']}>{salaryMaxFormatted}</span>
        </span>
      </>
    );
  };

  return (
    <StatesCountyMap
      {...props}
      svgFileUrl={svgFileUrl}
      gtmEventNames={gtmEventNames}
      embedWidgetType={WIDGET_NAMES.TITLE_SALARY_STATES_MAP}
      mapTooltip={mapTooltip}
      legendTooltip={legendTooltip}
      legendLabelsCallback={legendLabelsCallback}
    />
  );
};

export default TitleSalaryStatesMap;
